import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { ContractSubObjectCreateInput } from 'gql/graphql';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { uerCreateWorkOrderSubObjectGql } from '../../workOrderQueries';

const requestId = 'uerCreateWorkOrderSubObject';

export const useUerCreateWorkOrderSubObject = (workOrderId?: number, onSuccess?: (newObjectId?: number) => void) => {
    const dispatch = useDispatch();

    const [uerCreateWorkSubOrderObjectReset] = useResetStoreData({ requestId });

    const [
        uerCreateWorkOrderSubObjectData,
        uerCreateWorkOrderSubObjectStatus,
        uerCreateWorkOrderSubObjectError,
        uerCreateWorkOrderSubObjectRequest,
    ] = useRequest({
        requestId,
        query: uerCreateWorkOrderSubObjectGql,
        withEffect: false,
    });

    const uerCreateWorkOrderSubObjectRequestMakeRequest = useCallback(
        (input: ContractSubObjectCreateInput) => {
            dispatch(uerCreateWorkOrderSubObjectRequest({ workOrderId, input }));
        },
        [dispatch, uerCreateWorkOrderSubObjectRequest, workOrderId],
    );

    useEffect(() => {
        uerCreateWorkSubOrderObjectReset(undefined);
    }, [uerCreateWorkSubOrderObjectReset]);

    useEffect(() => {
        if (
            uerCreateWorkOrderSubObjectStatus === RequestStatus.SUCCESS &&
            uerCreateWorkOrderSubObjectData?.uerCreateWorkOrderSubObject?.data?.id
        ) {
            uerCreateWorkSubOrderObjectReset(undefined);
            onSuccess?.(uerCreateWorkOrderSubObjectData?.uerCreateWorkOrderSubObject?.data?.id);
        }
    }, [
        onSuccess,
        uerCreateWorkOrderSubObjectData?.uerCreateWorkOrderSubObject?.data?.id,
        uerCreateWorkSubOrderObjectReset,
        uerCreateWorkOrderSubObjectStatus,
    ]);

    return {
        uerCreateWorkOrderSubObjectData,
        uerCreateWorkOrderSubObjectStatus,
        uerCreateWorkOrderSubObjectError,
        uerCreateWorkOrderSubObjectRequestMakeRequest,
    };
};
